import { NotificationRow } from "@cnx/common";
import { Box, Flex, Stack, Text } from "@mantine/core";
import IconAlertOctagon from "icons/notification/alert-octagon.svg";
import ChangeRowCard from "./ChangeRowCard";

interface ChangeCardProps {
  notificationRows: NotificationRow[];
}

const ChangeCard: React.FC<ChangeCardProps> = ({ notificationRows }) => {
  const name = notificationRows[0].rowTypeName;
  const description = notificationRows[0].rowTypeDescription;

  return (
    <Flex align={"center"} p={15} gap={"sm"}>
      <Box>
        <IconAlertOctagon className="text-red-dark" width={24} height={24} />
      </Box>
      <Stack gap={2}>
        <Text lh={1} fw={600} c={"red.8"}>
          {name.toLocaleUpperCase()}
        </Text>
        {description && (
          <Text lh={1} fz={10} c={"gray.7"}>
            {description}
          </Text>
        )}
        <ChangeRowCard notificationRows={notificationRows} />
      </Stack>
    </Flex>
  );
};

export default ChangeCard;
